/*
 * @LastEditors: ttheitao
 * @Description: 用户状态
 * @FilePath: \onetab\src\store\user.ts
 * @Date: 2024-03-19 16:59:57
 * @LastEditTime: 2024-06-24 16:37:47
 * @Author: lisushuang
 */

import { reactive } from "vue";

export const user = reactive({
  email: "",
  username: "",
  avatar: "",

  token: "",

  backgroundImage: "", // 背景图片

  isVip: false,
  vipinfo: [],

  getToken() {
    return this.token;
  },
});
